<script setup>
import { useAttrs } from 'vue';

const attrs = useAttrs();
</script>

<template>
  <img
    v-bind="attrs"
    :src="'/namslogo/namsflow-icon.png?v=1'"
  />
</template>
